<template>
	<div class="cell el-tooltip">{{cellValue}}</div>
</template>

<script>
	export default {
		props: {
			cellValue: {
				type: String | Number,
				default: ''
			}
		}
	}
</script>

<style>
</style>
